import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { GrupoClienteRequest, Response } from './Types';

class GrupoClienteController {
  public static async Listar(request: GrupoClienteRequest): Promise<Response> {
    try {
      console.log('Controller GrupoCliente Listar');
      console.log(request);

      const response = await Api.post('api/grupocliente/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(GrupoClienteId: number): Promise<Response> {
    try {
      console.log('Controller GrupoCliente Listar Unico');
      console.log(GrupoClienteId);

      const response = await Api.get(
        `api/grupocliente/ListarUnico/${GrupoClienteId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: GrupoClienteRequest
  ): Promise<Response> {
    try {
      console.log('Controller GrupoCliente Adicionar');
      console.log(request);

      const response = await Api.post(`api/grupocliente/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: GrupoClienteRequest
  ): Promise<Response> {
    try {
      console.log('Controller GrupoCliente Atualizar');
      console.log(request);

      const response = await Api.put(`api/grupocliente/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: GrupoClienteRequest): Promise<Response> {
    try {
      console.log('Controller GrupoCliente Excluir');
      console.log(request);

      const response = await Api.put(`api/grupocliente/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default GrupoClienteController;
